<template>
  <div class="live-audio"  v-loading="downLoading" :element-loading-text="loadingText">
    <div class="live">
      <el-row>
          <el-button round type="primary" @click="toLink($router,'/course/audio-add',true)">新建音频</el-button>

        <div class="seach-list r iblock">
          <el-select class="input-v" v-model="search.status" @change="seachStatus">
            <el-option
              v-for="(item,index) in options"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input
            placeholder="搜索课程"
            v-model="search.keywords"
            round
            class="input-with-select input-sea r"
          >
            <el-button slot="append" icon="el-icon-search" @click="seachList()"></el-button>
          </el-input>
        </div>
      </el-row>
    </div>
    <!-- //表格数据 -->
    <div class="list-wrap" v-if="resultData.list&&resultData.list.length>=0" v-loading="loading">
      <div class="mt20">
        <span class="little-title">全部音频（{{resultData.count}}）条</span>
      </div>
      <el-table
        ref="table"
        stripe
        :data="resultData.list"
        :header-cell-style="{backgroundColor:'#f5f7fa'}"
        style="width: 100%;margin: 20px 0;"
      >
        <el-table-column prop="course_name" label="音频名称" min-width="160px"></el-table-column>
        <el-table-column prop="course_mode" label="音频类型" min-width="100px">
          <template slot-scope="scope">
            <span v-show="scope.row.course_mode==1">语音直播</span>
            <span v-show="scope.row.course_mode==2">语音录播</span>
            <span v-show="scope.row.course_mode==3">视频直播</span>
            <span v-show="scope.row.course_mode==3">视频录播</span>
          </template>
        </el-table-column>
        <el-table-column prop="subscribe_num" label="订阅量"></el-table-column>
        <el-table-column prop="course_sell_price" label="打赏金额" min-width="100px"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-show="scope.row.state==-1">删除</span>
            <span v-show="scope.row.state==1">定时上架</span>
            <span v-show="scope.row.state==2">已上架</span>
            <span v-show="scope.row.state==3">下架/未上架</span>
          </template>
        </el-table-column>
        <el-table-column prop="published_at" label="上架时间" min-width="150px"></el-table-column>
        <el-table-column prop="topic_name" label="关联专题" min-width="100px"></el-table-column>
        <el-table-column label="操作" fixed="right" width="260px">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="toLink($router,`/course/audio-edit/${scope.row.course_id}`,true)"
            >编辑</el-button>
            <el-button
              v-if="scope.row.state==2||scope.row.state==1"
              type="text"
              size="mini"
              @click="downline(courseOffline(),{course_id:scope.row.course_id},audioList)"
            >下架</el-button>
            <el-button
              v-if="scope.row.state==3"
              type="text"
              size="mini"
              @click="online(courseOnline(),{course_id:scope.row.course_id},audioList)"
            >上架</el-button>
            <el-button type="text" size="mini" @click="openShare(scope.row.course_id,1)">分享</el-button>
            <el-dropdown class="dropdown-btn" trigger="hover">
              <el-button type="text" size="small" class="ml10">
                更多
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <el-button type="text" size="small" @click="exportAudio(scope.row.course_id)">导出音频</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button
                    type="text"
                    size="small"
                    @click="toLink($router,`/course/discuss/${scope.row.course_id}`,true)"
                  >查看评论</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button
                    type="text"
                    size="small"
                    @click="delItem(courseDel(),{course_id:scope.row.course_id},audioList)"
                  >删除</el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <div class="tc mt20">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="Number(search.page)"
          :page-size="Number(search.size)"
          layout="total, prev, pager, next"
          :total="Number(resultData.count)"
        ></el-pagination>
      </div>
    </div>
    <!-- 修饰符传参，可以通过子组件的方法更新值的状态或者值 -->
    <template-guest :addCourseVisible.sync="addCourseVisible"></template-guest>
    <!-- 分享 -->
    <share-dialog :shareVisible.sync="shareVisible" :share_info="share_info"></share-dialog>
  </div>
</template>

<script>
//导入接口api
import { _audioList } from "@/api/audio";

//导入接口api
import {
  _courseAdd,
  _courseEdit,
  _courseOnline,
  _courseSingTopic,
  _courseOffline,
  _courseDel,
  _getCourseList,
  _courseWait
} from "@/api/course";

import { _exportAudioFile } from "@/api/export-file";

//引入嘉宾设置
import Guest from "../play-template/guests-setting-dialog";

//引入混合mixins模式
import course_mixins from "../play-template/course-mixins";

export default {
  created() {
    this.audioList();
  },
  mixins: [course_mixins],
  data() {
    return {
      downLoading: false, //下载文件的loading
      loadingText: "",//下载文件提示的loading
      loading: true,
      //嘉宾弹框设置
      addCourseVisible: false,
      live_href: "http://www.baidi.com",
      search: {
        keywords: "",
        status: "0",
        page:1,
        size:10
      },
      options: [
        {
          label: "全部状态",
          value: "0"
        },
        {
          label: "待上架",
          value: "1"
        },
        {
          label: "已上架",
          value: "2"
        },
        {
          label: "已下架",
          value: "3"
        }
      ],
      resultData: {},
    };
  },
  components: {
    "template-guest": Guest
  },
  methods: {
    //加载列表
    audioList() {
      _audioList({
        params: {
          page: this.search.page,
          size: this.search.size,
          keywords: this.search.keywords,
          state: this.search.status
        }
      }).then(res => {
        this.loading = false;
        if (res.resultCode == 1) {
          this.resultData = res.result;
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    // 上架
    courseOnline() {
      return _courseOnline;
    },
    //下架
    courseOffline() {
      return _courseOffline;
    },
    //删除
    courseDel() {
      return _courseDel;
    },
    //状态查询信息
    seachStatus(val) {
      this.chearSearchState();
      this.audioList();
    },
    //关键字查询信息
    seachList() {
      this.chearSearchState();
      this.audioList();
    },
    // 编辑：
    edit() {
      const userId = "123";
      let routeData = this.$router.resolve({
        path: `/course/live-edit/${userId}`
      });
      window.open(routeData.href, "_blank");
    },
    //翻页
    handleCurrentChange(val) {
      // console.log(val);
      this.search.page = val;
      this.audioList();
    },
    //导出音频
    exportAudio(id) {
      _exportAudioFile({
        params: {
          course_id: id
        }
      }).then(res => {
        if (res.resultCode == 1) {
          window.open(res.result.link, "_self");
        } else {
          this.loadingText = res.errorMsg;
          this.downLoading = true;
          setTimeout(() => {
            this.downLoading = false;
          }, 2000);
        }
      });
    },
    //嘉宾设置
    guestSettings() {
      this.addCourseVisible = true;
    },
    //复制链接
    copyLink(item) {
      let that = this;
      this.$copyText(this.live_href).then(
        function(e) {
          that.$message.success("复制成功");
          // console.log(e)
        },
        function(e) {
          that.$message.error("复制失败");
          // console.log(e)
        }
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.live-audio{
   min-height: 500px;
  overflow: hidden;
.live {
  .seach-list {
    .input-v {
      // width: 160px;
      margin-left: 20px;
    }
    .input-sea {
      margin-left: 20px;
      width: 280px;
      border-radius: 5px;
    }
  }
}
.img_code {
  width: 150px;
  height: 150px;
  border: 1px solid #000;
  margin: 0 auto;
  margin-top: 20px;
  img {
    width: 100%;
  }
}
}
</style>